import React, { memo, useCallback } from 'react';
import EDGrid from '../../../../../../BaseComponents/GridComponents/EDGrid';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { URVAL_INDENT } from '../../../../Consts/UrvalConsts';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { ITypeConditionInfo } from '../../../../Utils/urvalUtils';
import { ConditionValues } from '../../../Condition/Components/ConditionValues/ConditionValues';
import { UIUrvalConditionObjectType } from '../../../../../../Types/UrvalTypes';
import { ifDefined } from '../../../../../../Utils/checkUtils';
import Logger from '../../../../../../Utils/Logger';

interface IProps {
  typeConditionInfo?: ITypeConditionInfo;
  deletePage: () => void;
  pageNr: number;
  collectionName: string;
  indention: number;
  disabled?: boolean;
  setConditionObject: (
    index: number,
    typeConditionInfo: ITypeConditionInfo | undefined,
    newConditionObject: UIUrvalConditionObjectType
  ) => void;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    marginTop: theme.spacing(4),
    color: theme.customProperties.Fade.DarkOnLight.lowEmphasis,
  },
  pageLabel: {
    display: 'flex',
    alignItems: 'center',
  },
});

/**
 * En header för ett extended urval.
 */
export const ExtendedUrvalSidaHeader: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { setConditionObject } = props;
  const setTypeConditionObject = useCallback(
    (newConditionObject: UIUrvalConditionObjectType) => {
      if (props.typeConditionInfo) {
        setConditionObject(
          props.typeConditionInfo.index,
          props.typeConditionInfo,
          newConditionObject
        );
      }
    },
    [setConditionObject, props.typeConditionInfo]
  );

  const deleteConditionObject = useCallback(() => {
    Logger.error('Can not delete type condition');
  }, []);

  const {
    classes,
    indention,
    deletePage,
    pageNr,
    typeConditionInfo,
    disabled,
  } = props;

  return (
    <EDGrid container spacing={0} className={classes.container}>
      <EDGrid item xs={5}>
        <div
          className={classes.pageLabel}
          style={{ paddingLeft: indention * URVAL_INDENT }}
        >
          <EDIconButton
            color="inherit"
            icon="close"
            tooltip="Ta bort sida"
            onClick={deletePage}
            margin="none"
          />
          <EDTypography
            variant="subtitle1"
            color={disabled ? 'textSecondary' : 'initial'}
          >
            Sida {pageNr}
          </EDTypography>
        </div>
      </EDGrid>
      <EDGrid item xs={2} />
      <EDGrid item xs={5}>
        {typeConditionInfo && (
          <ConditionValues
            conditionObject={typeConditionInfo.object}
            setConditionObject={setTypeConditionObject}
            deleteConditionObject={deleteConditionObject}
            disabled={ifDefined<boolean>(disabled, false)}
          />
        )}
      </EDGrid>
    </EDGrid>
  );
};

export default withStyles(memo(ExtendedUrvalSidaHeader), styles);
